module.exports = __webpack_public_path__ + "img/2GPS.97c30e2d.gif";